import LiveEvents from '~/components/LiveEvents';

export const route = {
  preload: () => {},
} satisfies RouteDefinition;

export default function Page() {
  return <LiveEvents />;
}
